<template>
  <div class="fileTemplates">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        文件模板
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索模板名称/描述"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="c-m-l-10" @click="doNew()">
          新建文件模板
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                beanName: 'template',
                title: '文件模板'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="getHistory(scope.row._id)">
                    查看历史记录
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="文件模板" :visible.sync="openDetail" :close-on-click-modal="false">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="模板历史记录"
      :visible.sync="history.show"
      :close-on-click-modal="false"
      @close="doInitHistory()"
      width="900px"
    >
      <div class="content-table">
        <el-table
          ref="history"
          :data="history.fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
        >
          <c-table :fields="extFields">
            <template slot="state">
              <el-table-column label="状态">无效</el-table-column>
            </template>
          </c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="history.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="history.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="history.fpi.total"
        ></el-pagination>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="doInitHistory()">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'FileTemplates',
  data() {
    window.$this = this;
    return {
      name: 'template',
      fpi: { data: [] },
      history: {
        show: false,
        fpi: { data: [] },
        templateId: ''
      },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        exts: { url: [] }
      },
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {}
      }
    };
  },
  mounted() {
    this.osg.getFields('template', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      if (this.history.show) {
        this.history.fpi.rows = pageSize;
        this.getHistory();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.history.show) {
        this.history.fpi.page = currentPage;
        this.getHistory();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        sortField: 'order,createTime',
        sortOrder: 'asc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/template/queryTemplate.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: { url: [] }
      };
    },
    doSave() {
      if (this.osg.validate()) {
        this.formData.url = this.upload.downloadUrl + this.formData.exts.url[0].response.key;
        this.formData.exts.url = JSON.stringify(this.formData.exts.url);
        this.osg.ajax('/basic/template/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    // doEnable(id) {
    //   this.osg.ajax('basic/template/enable.do', { id }, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doDisable(id) {
    //   this.osg.ajax('basic/template/disable.do', { id }, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doRemove(id) {
    //   this.osg.confirm('是否确认删除？', () => {
    //     this.osg.ajax('basic/template/remove.do', { id }, () => {
    //       this.getData();
    //       this.osg.toast('删除成功！');
    //     });
    //   });
    // },
    doInitHistory() {
      console.log('doInitHistory');
      this.history = {
        show: false,
        fpi: { data: [] },
        templateId: ''
      };
    },
    getHistory(id) {
      if (id) {
        this.history.templateId = id;
      } else {
        id = this.history.templateId;
      }
      this.osg.ajax(
        'basic/template/queryTemplateHistory.do',
        {
          templateId: id,
          'is:state|integer#and': 1,
          page: this.history.fpi.page || 1,
          rows: this.history.fpi.rows || 20
        },
        res => {
          this.history.fpi = res;
          this.history.show = true;
          this.$nextTick(() => {
            this.$refs.history.doLayout();
            this.$forceUpdate();
          });
        }
      );
    }
  }
};
</script>
